var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42.009,
    height: 38.887,
    viewBox: "0 0 42.009 38.887",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_16623",
    x: 0,
    y: 0,
    width: 42.009,
    height: 38.887,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_51231",
    "data-name": "Group 51231",
    transform: "translate(-128.473 -143.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47532",
    "data-name": "Group 47532",
    transform: "translate(157.33 153.572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10177",
    "data-name": "Rectangle 10177",
    transform: "translate(-0.33 0.428)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 17,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 12.5,
    height: 16.5,
    rx: 0.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_16615",
    "data-name": "Path 16615",
    transform: "translate(1.363 9.121)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.456309795379639 2.712619781494141 C 0.763579785823822 2.712619781494141 0.1999997943639755 2.149039745330811 0.1999997943639755 1.456309795379639 C 0.1999997943639755 0.763579785823822 0.763579785823822 0.1999997943639755 1.456309795379639 0.1999997943639755 C 2.149039745330811 0.1999997943639755 2.712619781494141 0.763579785823822 2.712619781494141 1.456309795379639 C 2.712619781494141 2.149039745330811 2.149039745330811 2.712619781494141 1.456309795379639 2.712619781494141 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.456309795379639 0.3999998569488525 C 0.8738598823547363 0.3999998569488525 0.3999998569488525 0.8738598823547363 0.3999998569488525 1.456309795379639 C 0.3999998569488525 2.038759708404541 0.8738598823547363 2.512619733810425 1.456309795379639 2.512619733810425 C 2.038759708404541 2.512619733810425 2.512619733810425 2.038759708404541 2.512619733810425 1.456309795379639 C 2.512619733810425 0.8738598823547363 2.038759708404541 0.3999998569488525 1.456309795379639 0.3999998569488525 M 1.456309795379639 -2.384185791015625e-07 C 2.260609865188599 -2.384185791015625e-07 2.912619829177856 0.6520097255706787 2.912619829177856 1.456309795379639 C 2.912619829177856 2.260609865188599 2.260609865188599 2.912619829177856 1.456309795379639 2.912619829177856 C 0.6520097255706787 2.912619829177856 -2.384185791015625e-07 2.260609865188599 -2.384185791015625e-07 1.456309795379639 C -2.384185791015625e-07 0.6520097255706787 0.6520097255706787 -2.384185791015625e-07 1.456309795379639 -2.384185791015625e-07 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_16634",
    "data-name": "Path 16634",
    transform: "translate(1.363 5.363)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.456309795379639 2.712619781494141 C 0.763579785823822 2.712619781494141 0.1999997943639755 2.149039745330811 0.1999997943639755 1.456309795379639 C 0.1999997943639755 0.763579785823822 0.763579785823822 0.1999997943639755 1.456309795379639 0.1999997943639755 C 2.149039745330811 0.1999997943639755 2.712619781494141 0.763579785823822 2.712619781494141 1.456309795379639 C 2.712619781494141 2.149039745330811 2.149039745330811 2.712619781494141 1.456309795379639 2.712619781494141 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.456309795379639 0.3999998569488525 C 0.8738598823547363 0.3999998569488525 0.3999998569488525 0.8738598823547363 0.3999998569488525 1.456309795379639 C 0.3999998569488525 2.038759708404541 0.8738598823547363 2.512619733810425 1.456309795379639 2.512619733810425 C 2.038759708404541 2.512619733810425 2.512619733810425 2.038759708404541 2.512619733810425 1.456309795379639 C 2.512619733810425 0.8738598823547363 2.038759708404541 0.3999998569488525 1.456309795379639 0.3999998569488525 M 1.456309795379639 -2.384185791015625e-07 C 2.260609865188599 -2.384185791015625e-07 2.912619829177856 0.6520097255706787 2.912619829177856 1.456309795379639 C 2.912619829177856 2.260609865188599 2.260609865188599 2.912619829177856 1.456309795379639 2.912619829177856 C 0.6520097255706787 2.912619829177856 -2.384185791015625e-07 2.260609865188599 -2.384185791015625e-07 1.456309795379639 C -2.384185791015625e-07 0.6520097255706787 0.6520097255706787 -2.384185791015625e-07 1.456309795379639 -2.384185791015625e-07 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_16635",
    "data-name": "Path 16635",
    transform: "translate(1.363 1.8)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.456309795379639 2.712619781494141 C 0.763579785823822 2.712619781494141 0.1999997943639755 2.149039745330811 0.1999997943639755 1.456309795379639 C 0.1999997943639755 0.763579785823822 0.763579785823822 0.1999997943639755 1.456309795379639 0.1999997943639755 C 2.149039745330811 0.1999997943639755 2.712619781494141 0.763579785823822 2.712619781494141 1.456309795379639 C 2.712619781494141 2.149039745330811 2.149039745330811 2.712619781494141 1.456309795379639 2.712619781494141 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.456309795379639 0.3999998569488525 C 0.8738598823547363 0.3999998569488525 0.3999998569488525 0.8738598823547363 0.3999998569488525 1.456309795379639 C 0.3999998569488525 2.038759708404541 0.8738598823547363 2.512619733810425 1.456309795379639 2.512619733810425 C 2.038759708404541 2.512619733810425 2.512619733810425 2.038759708404541 2.512619733810425 1.456309795379639 C 2.512619733810425 0.8738598823547363 2.038759708404541 0.3999998569488525 1.456309795379639 0.3999998569488525 M 1.456309795379639 -2.384185791015625e-07 C 2.260609865188599 -2.384185791015625e-07 2.912619829177856 0.6520097255706787 2.912619829177856 1.456309795379639 C 2.912619829177856 2.260609865188599 2.260609865188599 2.912619829177856 1.456309795379639 2.912619829177856 C 0.6520097255706787 2.912619829177856 -2.384185791015625e-07 2.260609865188599 -2.384185791015625e-07 1.456309795379639 C -2.384185791015625e-07 0.6520097255706787 0.6520097255706787 -2.384185791015625e-07 1.456309795379639 -2.384185791015625e-07 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_16616",
    "data-name": "Path 16616",
    transform: "translate(1.363 12.475)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.456309795379639 2.712619781494141 C 0.763579785823822 2.712619781494141 0.1999997943639755 2.149039745330811 0.1999997943639755 1.456309795379639 C 0.1999997943639755 0.763579785823822 0.763579785823822 0.1999997943639755 1.456309795379639 0.1999997943639755 C 2.149039745330811 0.1999997943639755 2.712619781494141 0.763579785823822 2.712619781494141 1.456309795379639 C 2.712619781494141 2.149039745330811 2.149039745330811 2.712619781494141 1.456309795379639 2.712619781494141 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.456309795379639 0.3999998569488525 C 0.8738598823547363 0.3999998569488525 0.3999998569488525 0.8738598823547363 0.3999998569488525 1.456309795379639 C 0.3999998569488525 2.038759708404541 0.8738598823547363 2.512619733810425 1.456309795379639 2.512619733810425 C 2.038759708404541 2.512619733810425 2.512619733810425 2.038759708404541 2.512619733810425 1.456309795379639 C 2.512619733810425 0.8738598823547363 2.038759708404541 0.3999998569488525 1.456309795379639 0.3999998569488525 M 1.456309795379639 -2.384185791015625e-07 C 2.260609865188599 -2.384185791015625e-07 2.912619829177856 0.6520097255706787 2.912619829177856 1.456309795379639 C 2.912619829177856 2.260609865188599 2.260609865188599 2.912619829177856 1.456309795379639 2.912619829177856 C 0.6520097255706787 2.912619829177856 -2.384185791015625e-07 2.260609865188599 -2.384185791015625e-07 1.456309795379639 C -2.384185791015625e-07 0.6520097255706787 0.6520097255706787 -2.384185791015625e-07 1.456309795379639 -2.384185791015625e-07 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_5899",
    "data-name": "Line 5899",
    x2: 5.597,
    transform: "translate(5.17 3.113)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5900",
    "data-name": "Line 5900",
    x2: 5.597,
    transform: "translate(5.17 6.722)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5901",
    "data-name": "Line 5901",
    x2: 5.597,
    transform: "translate(5.17 10.738)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5902",
    "data-name": "Line 5902",
    x2: 5.597,
    transform: "translate(5.17 14.191)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-alert-triangle",
    "data-name": "Icon feather-alert-triangle",
    transform: "translate(138 150.131)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.53, -6.63)",
    filter: "url(#Path_16623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16623-2",
    "data-name": "Path 16623",
    d: "M15.684,5.4l9.3,15.533a2.2,2.2,0,0,1-1.879,3.3H4.5a2.2,2.2,0,0,1-1.878-3.3L11.927,5.4a2.2,2.2,0,0,1,3.757,0Z",
    transform: "translate(7.2 3.15)",
    fill: "#fff",
    stroke: "#9b2323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51232",
    "data-name": "Group 51232",
    transform: "translate(11.478 6.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16624",
    "data-name": "Path 16624",
    d: "M18,13.5v6.265",
    transform: "translate(-18 -13.5)",
    fill: "none",
    stroke: "#93312a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16625",
    "data-name": "Path 16625",
    d: "M18,25.5h0",
    transform: "translate(-18 -16.119)",
    fill: "none",
    stroke: "#93312a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedIcon);
export default __webpack_public_path__ + "static/media/failed-icon.addf1024d1101fb38d599f8070d05367.svg";
export { ForwardRef as ReactComponent };